import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-espresso text-bone pt-16 pb-8 border-t border-white/10" data-id="element-51" data-mp="32o4c8dvrme84">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-52" data-mp="36pft9v0kpr4p">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-53" data-mp="36pzblcu4yhj9">
          <div className="md:col-span-2" data-id="element-54" data-mp="3uesa9h2573hk">
            <a href="#" className="block mb-6" data-id="element-55" data-mp="3uftkjjbc3ly8">
              <Logo variant="dark" size="md" data-id="element-56" data-mp="39904ifsbca6" />
            </a>
            <p className="text-bone/70 font-light max-w-sm leading-relaxed mb-6" data-id="element-57" data-mp="36d2ywbrgrms">
              Carpintería arquitectónica de alto impacto. Fabricación industrial
              y diseño de autor para proyectos residenciales y grandes
              constructoras.
            </p>
            <div className="flex space-x-4" data-id="element-58" data-mp="29xvq6ay3z9o9">
              <a href="https://www.instagram.com/carpinteriagym/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Carpintería G&M" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-espresso transition-all duration-300" data-id="element-59" data-mp="2ey0bce9yoskt">
                <Instagram size={18} data-id="element-60" data-mp="3q8di31xev8bv" />
              </a>
              <a href="https://web.facebook.com/profile.php?id=61553537645971&locale=es_LA" target="_blank" rel="noopener noreferrer" aria-label="Facebook de Carpintería G&M" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-gold hover:border-gold hover:text-espresso transition-all duration-300" data-id="element-61" data-mp="3qazrl73v3xwq">
                <Facebook size={18} data-id="element-62" data-mp="qsqfub6lr0v1" />
              </a>
            </div>
          </div>

          <div data-id="element-63" data-mp="msg5ynfovqaw">
            <h4 className="text-gold font-serif text-lg mb-6" data-id="element-64" data-mp="msxzhcayvqf4">Contacto</h4>
            <ul className="space-y-4 text-bone/70 font-light" data-id="element-65" data-mp="tvmr3jy8gkmy">
              <li className="flex items-start" data-id="element-66" data-mp="tt09ssljiqrj">
                <MapPin size={18} className="mr-3 mt-1 text-gold shrink-0" data-id="element-67" data-mp="ytejsg6pcas7" />
                <span data-id="element-68" data-mp="13tkek589qdei">
                  Planta Principal
                  <br data-id="element-69" data-mp="13rzi2a2e8ke0" />
                  Carrera 25 # 57-51
                  <br data-id="element-70" data-mp="18k93pdwh6yah" />
                  Manizales, Colombia, 170004
                </span>
              </li>
              <li className="flex items-center" data-id="element-71" data-mp="1ckkpwv4hl6o2">
                <Phone size={18} className="mr-3 text-gold shrink-0" data-id="element-72" data-mp="1cnyodsa14vq8" />
                <span data-id="element-73" data-mp="1hj4dt12n4sj2">+57 312 876 7638 / +57 311 746 7135</span>
              </li>
              <li className="flex items-center" data-id="element-74" data-mp="1ml3gs9ugxnfh">
                <Mail size={18} className="mr-3 text-gold shrink-0" data-id="element-75" data-mp="1riv5kuztgtfg" />
                <span data-id="element-76" data-mp="1ri3kwf7rcg3y">diseno.gymcarpinteria@gmail.com</span>
              </li>
            </ul>
          </div>

          <div data-id="element-77" data-mp="3od85lcgo84lz">
            <h4 className="text-gold font-serif text-lg mb-6" data-id="element-78" data-mp="3ta8ahk1sb1bi">Enlaces</h4>
            <ul className="space-y-3 text-bone/70 font-light" data-id="element-79" data-mp="3tahyj239qyek">
              <li data-id="element-80" data-mp="2ag5eqppkvag4">
                <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-81" data-mp="2agokz95v8aeb">
                  Líneas de Negocio
                </a>
              </li>
              <li data-id="element-82" data-mp="21n1t3u4s3rae">
                <a href="#cobertura" className="hover:text-gold transition-colors" data-id="element-83" data-mp="21kfl5tdz79rn">
                  Cobertura Nacional
                </a>
              </li>
              <li data-id="element-84" data-mp="2pcnrwgh8o4hv">
                <a href="#portafolio" className="hover:text-gold transition-colors" data-id="element-85" data-mp="2pc4kvut4n0im">
                  Portafolio
                </a>
              </li>
              <li data-id="element-86" data-mp="2fezv7l02omx2">
                <a href="#contacto" className="hover:text-gold transition-colors" data-id="element-87" data-mp="2fdf4k6gvpo4h">
                  Solicitar Asesoría
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-bone/50 font-light" data-id="element-88" data-mp="2rvzjv5ri1rq0">
          <p data-id="element-89" data-mp="2wo0tsl1736cv">
            &copy; {currentYear} Carpintería G&M. Todos los derechos reservados.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-90" data-mp="2iww1y542jid3">Diseño y Manufactura Premium</p>
        </div>
      </div>
    </footer>;
}